import { ArrowDownTrayIcon, EyeIcon } from "@heroicons/react/24/outline";
import { IconButton, Modal } from "../../../../../../../components/ui";
import { isPreviewableDocument } from "../../../../../../../util/documentPreview";
import CopyDocumentLinkButton from "../../../../../../../components/Documents/CopyDocumentLinkButton";

const Actions = props => {
  const { id, values } = props || {};
  const canPreviewInModal = isPreviewableDocument(values);

  const viewModalProps = {
    title: values?.fileName ?? "Document Preview",
    scale: "fullscreen",
    renderBody: () => {
      return (
        <div className="mt-4 h-[85vh] w-full">
          <iframe
            title={values?.fileName ?? "Document Preview"}
            src={values?.viewUrl}
            className="h-full w-full rounded-md border border-gray-200"
          />
        </div>
      );
    },
  };

  if (typeof id !== "number") {
    return (
      <div className="user-list-actions flex text-right text-sm font-medium">
        {id && (
          <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-4">
            <CopyDocumentLinkButton fileName={values?.fileName} />
            {canPreviewInModal ? (
              <Modal {...viewModalProps}>
                <IconButton variant="clean" title="View Document">
                  <EyeIcon className={`h-4 w-4 cursor-pointer text-gray-400`} />
                </IconButton>
              </Modal>
            ) : (
              <IconButton
                variant="clean"
                title="Preview not available for this file type"
              >
                <EyeIcon className={`h-4 w-4 cursor-not-allowed text-gray-300`} />
              </IconButton>
            )}
            <IconButton variant="clean" title="Download Document">
              <ArrowDownTrayIcon
                className={`h-4 w-4 cursor-pointer text-gray-400`}
                onClick={() => {
                  window.open(values?.url, "_blank");
                }}
              />
            </IconButton>
          </div>
        )}
      </div>
    );
  } else {
    return false;
  }
};

export default Actions;
